/**
 * @generated SignedSource<<7667c571c254e7eb5ea28edfd58780ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StorecastSpaceDeleteWidgetMutation$variables = {
  id: string;
  widgetId: string;
};
export type StorecastSpaceDeleteWidgetMutation$data = {
  readonly storecastSpace: {
    readonly deleteWidget: {
      readonly id: string;
      readonly subWidgets: ReadonlyArray<{
        readonly id: string;
      }>;
    };
  } | null;
};
export type StorecastSpaceDeleteWidgetMutation = {
  response: StorecastSpaceDeleteWidgetMutation$data;
  variables: StorecastSpaceDeleteWidgetMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "widgetId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "widgetId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StorecastSpaceDeleteWidgetMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "StorecastSpaceMutation",
        "kind": "LinkedField",
        "name": "storecastSpace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "StorecastSpace",
            "kind": "LinkedField",
            "name": "deleteWidget",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "subWidgets",
                "plural": true,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StorecastSpaceDeleteWidgetMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "StorecastSpaceMutation",
        "kind": "LinkedField",
        "name": "storecastSpace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "StorecastSpace",
            "kind": "LinkedField",
            "name": "deleteWidget",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "subWidgets",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "96582f191735bc27ef0b618dd15fed80",
    "id": null,
    "metadata": {},
    "name": "StorecastSpaceDeleteWidgetMutation",
    "operationKind": "mutation",
    "text": "mutation StorecastSpaceDeleteWidgetMutation(\n  $id: ID!\n  $widgetId: ID!\n) {\n  storecastSpace(id: $id) {\n    deleteWidget(id: $widgetId) {\n      id\n      subWidgets {\n        __typename\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fc58a45ee6362447a3d70b34c93d5aa9";

export default node;
